import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixPopover from "@radix-ui/react-popover";
import { memo } from "react";
export const ComboboxTrigger = /*#__PURE__*/ memo((props)=>{
    return /*#__PURE__*/ _jsx(RadixPopover.Trigger, {
        "data-testid": "COMBOBOX_TRIGGER",
        ...props
    });
});
ComboboxTrigger.displayName = "ComboboxTrigger";
